export const APP_ONLINE_STATUS = 'APP_ONLINE_STATUS'
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS'
export const APP_SWITCH_OFF_DESIGN_BANNER = 'APP_SWITCH_OFF_DESIGN_BANNER'
export const APP_SET_IS_ONBOARDING = 'APP_SET_IS_ONBOARDING'
export const APP_SEARCH_PAGE_SHORTLIST_TOGGLE =
  'APP_SEARCH_PAGE_SHORTLIST_TOGGLE'
export const APP_SKIP_ONBOARDING = 'APP_SKIP_ONBOARDING'
export const APP_REQUEST_STARTED = 'APP_REQUEST_STARTED'
export const APP_REQUEST_COMPLETED = 'APP_REQUEST_COMPLETED'
export const APP_REQUEST_RESET = 'APP_REQUEST_RESET'
export const APP_PLAYLIST_CREATOR_SETTINGS_UPDATED =
  'APP_PLAYLIST_CREATOR_SETTINGS_UPDATED'
export const APP_PLAYLIST_CREATOR_WIDTH_UPDATED =
  'APP_PLAYLIST_CREATOR_WIDTH_UPDATED'
export const APP_PAGE_CHANGE_LOAD = 'APP_PAGE_CHANGE_LOAD'
export const APP_URL_REDIRECT = 'APP_URL_REDIRECT'

export const SCREEN_CHANGES = 'SCREEN_CHANGES'
export const GENERIC_ERROR_SEND = 'GENERIC_ERROR_SEND'
export const PANE_LOAD = 'PANE_LOAD'
export const PANE_LOAD_SUCCESS = 'PANE_LOAD_SUCCESS'
export const PANE_LOAD_FAIL = 'PANE_LOAD_FAIL'
export const PANE_UPDATE = 'PANE_UPDATE'
export const PANES_UPDATE = 'PANES_UPDATE'
export const PANE_RECENTS_PUSH = 'PANE_RECENTS_PUSH'
export const PLAYBACK_PANE_UPDATE = 'PLAYBACK_PANE_UPDATE'
export const BRIEF_PANE_UPDATE = 'BRIEF_PANE_UPDATE'
export const USER_STATE_UPDATE = 'USER_STATE_UPDATE'
export const USER_STATE_UPDATE_SUCCESS = 'USER_STATE_UPDATE_SUCCESS'
export const USER_STATE_UPDATE_FAIL = 'USER_STATE_UPDATE_FAIL'
export const START_SAVING_STATE = 'START_SAVING_STATE'
export const LOAD_SAVED_STATE = 'LOAD_SAVED_STATE'
export const LOAD_SAVED_STATE_ERROR = 'LOAD_SAVED_STATE_ERROR'
export const EXPLORER_UPDATE = 'EXPLORER_UPDATE'
export const EXPLORER_UPLOADS_ADD = 'EXPLORER_UPLOADS_ADD'
export const EXPLORER_UPLOADS_REMOVE = 'EXPLORER_UPLOADS_REMOVE'
export const EXPLORER_UPLOAD_UPDATE = 'EXPLORER_UPLOAD_UPDATE'
export const EXPLORER_CLOSE_PANE = 'EXPLORER_CLOSE_PANE'
export const TRACK_PRELOAD = 'TRACK_PRELOAD'
export const TRACK_PLAY = 'TRACK_PLAY'
export const TRACK_MEDIA_PROPERTIES_UPDATE = 'TRACK_MEDIA_PROPERTIES_UPDATE'
export const TRACK_ACTIVATE = 'TRACK_ACTIVATE'
export const TRACK_PAUSE = 'TRACK_PAUSE'
export const TRACK_STOP = 'TRACK_STOP'
export const TRACK_RESET = 'TRACK_RESET'
export const TRACK_STATUS_UPDATE = 'TRACK_STATUS_UPDATE'
export const TRACK_DURATION_UPDATE = 'TRACK_DURATION_UPDATE'
export const TRACK_PLAY_PROGRESS_UPDATE = 'TRACK_PLAY_PROGRESS_UPDATE'
export const TRACK_SEEK = 'TRACK_SEEK'
export const TRACK_PLAYLIST_PAGE_LOAD = 'TRACK_PLAYLIST_PAGE_LOAD'
export const TRACK_PLAYLIST_PAGE_LOAD_SUCCESS =
  'TRACK_PLAYLIST_PAGE_LOAD_SUCCESS'
export const TRACK_PLAYLIST_PAGE_LOAD_ERROR = 'TRACK_PLAYLIST_PAGE_LOAD_ERROR'
export const TRACK_WAVEFORM_LOAD = 'TRACK_WAVEFORM_LOAD'
export const TRACK_WAVEFORM_LOAD_SUCCESS = 'TRACK_WAVEFORM_LOAD_SUCCESS'
export const TRACK_WAVEFORM_LOAD_ERROR = 'TRACK_WAVEFORM_LOAD_ERROR'
export const TRACK_SHARE = 'TRACK_SHARE'
export const TRACK_SHARE_ERROR = 'TRACK_SHARE_ERROR'
export const TRACK_SHARE_SUCCESS = 'TRACK_SHARE_SUCCESS'
export const TRACK_SHARES_LOADING = 'TRACK_SHARES_LOADING'
export const TRACK_SHARES_LOADING_SUCCESS = 'TRACK_SHARES_LOADING_SUCCESS'
export const TRACK_SHARES_LOADING_ERROR = 'TRACK_SHARES_LOADING_ERROR'
export const VOLUME_CHANGE = 'VOLUME_CHANGE'
export const BACKGROUND_PLAYBACK_SERVICE_STATUS_SYNC =
  'BACKGROUND_PLAYBACK_SERVICE_STATUS_SYNC'
export const EDITED_TRACK_INIT = 'EDITED_TRACK_INIT'
export const EDITED_TRACK_UPDATE = 'EDITED_TRACK_UPDATE'
// old track actions
export const TRACK_METADATA_FETCH = 'TRACK_METADATA_FETCH'
export const TRACK_METADATA_FETCH_SUCCESS = 'TRACK_METADATA_FETCH_SUCCESS'
export const TRACK_METADATA_FETCH_ERROR = 'TRACK_METADATA_FETCH_ERROR'
export const TRACK_METADATA_SAVE = 'TRACK_METADATA_SAVE'
export const TRACK_METADATA_SAVE_SUCCESS = 'TRACK_METADATA_SAVE_SUCCESS'
export const TRACK_METADATA_SAVE_ERROR = 'TRACK_METADATA_SAVE_ERROR'
export const TRACK_PERMISSIONS_SAVE = 'TRACK_PERMISSIONS_SAVE'
export const TRACK_PERMISSIONS_SAVE_SUCCESS = 'TRACK_PERMISSIONS_SAVE_SUCCESS'
export const TRACK_PERMISSIONS_SAVE_ERROR = 'TRACK_PERMISSIONS_SAVE_ERROR'
export const TRACK_GROUP_CHANGE = 'TRACK_GROUP_CHANGE'
export const TRACK_GROUP_CHANGE_SUCCESS = 'TRACK_GROUP_CHANGE_SUCCESS'
export const TRACK_GROUP_CHANGE_ERROR = 'TRACK_GROUP_CHANGE_ERROR'
// new track actions
export const TRACK_LOAD_BATCH = 'TRACK_LOAD_BATCH'
export const TRACK_CREATE = 'TRACK_CREATE'
export const TRACK_CREATE_SUCCESS = 'TRACK_CREATE_SUCCESS'
export const TRACK_CREATE_FAIL = 'TRACK_CREATE_FAIL'
export const TRACK_UPDATE = 'TRACK_UPDATE'
export const TRACK_UPDATE_SUCCESS = 'TRACK_UPDATE_SUCCESS'
export const TRACK_UPDATE_ERROR = 'TRACK_UPDATE_ERROR'
export const TRACK_DELETE_BATCH = 'TRACK_DELETE_BATCH'
export const TRACK_DELETE_BATCH_SUCCESS = 'TRACK_DELETE_BATCH_SUCCESS'
export const TRACK_DELETE_BATCH_ERROR = 'TRACK_DELETE_BATCH_ERROR'
export const TRACK_FORMAT_DELETE = 'TRACK_FORMAT_DELETE'
export const TRACK_FORMAT_DELETE_SUCCESS = 'TRACK_FORMAT_DELETE_SUCCESS'
export const TRACK_FORMAT_DELETE_ERROR = 'TRACK_FORMAT_DELETE_ERROR'
export const TRACK_ALBUM_ARTWORK_UPDATE = 'TRACK_ALBUM_ARTWORK_UPDATE'
export const TRACK_MERGE = 'TRACK_MERGE'
export const TRACK_MERGE_SUCCESS = 'TRACK_MERGE_SUCCESS'
export const TRACK_MERGE_ERROR = 'TRACK_MERGE_ERROR'
export const TRACK_ADD_WRITER = 'TRACK_ADD_WRITER'
export const TRACK_ADD_WRITER_SUCCESS = 'TRACK_ADD_WRITER_SUCCESS'
export const TRACK_ADD_WRITER_FAIL = 'TRACK_ADD_WRITER_FAIL'
export const TRACK_DELETE_WRITER = 'TRACK_DELETE_WRITER'
export const TRACK_DELETE_WRITER_SUCCESS = 'TRACK_DELETE_WRITER_SUCCESS'
export const TRACK_DELETE_WRITER_FAIL = 'TRACK_DELETE_WRITER_FAIl'
export const TRACK_UPDATE_WRITER = 'TRACK_UPDATE_WRITER'
export const TRACK_UPDATE_WRITER_SUCCESS = 'TRACK_UPDATE_WRITER_SUCCESS'
export const TRACK_UPDATE_WRITER_FAIL = 'TRACK_UPDATE_WRITER_FAIL'
export const TRACKS_TRANSCRIBE = 'TRACKS_TRANSCRIBE'
export const TRACKS_UPDATE = 'TRACKS_UPDATE'
export const TRANSCRIPTION_FEEDBACK_SEND = 'TRANSCRIPTION_FEEDBACK_SEND'
// old playlist actions
export const PLAYLIST_METADATA_SAVE = 'PLAYLIST_METADATA_SAVE'
export const PLAYLIST_METADATA_SAVE_SUCCESS = 'PLAYLIST_METADATA_SAVE_SUCCESS'
export const PLAYLIST_METADATA_SAVE_ERROR = 'PLAYLIST_METADATA_SAVE_ERROR'
export const PLAYLIST_DELETE_BATCH = 'PLAYLIST_DELETE_BATCH'
export const PLAYLIST_DELETE_BATCH_SUCCESS = 'PLAYLIST_DELETE_BATCH_SUCCESS'
export const PLAYLIST_DELETE_BATCH_ERROR = 'PLAYLIST_DELETE_BATCH_ERROR'
export const PLAYLIST_VERSION_DELETE = 'PLAYLIST_VERSION_DELETE'
export const PLAYLIST_VERSION_DELETE_SUCCESS = 'PLAYLIST_VERSION_DELETE_SUCCESS'
export const PLAYLIST_VERSION_DELETE_ERROR = 'PLAYLIST_VERSION_DELETE_ERROR'
export const PLAYLIST_VERSION_REPLACE_SUCCESS =
  'PLAYLIST_VERSION_REPLACE_SUCCESS'
// new playlist actions
export const PLAYLIST_LOAD_BATCH = 'PLAYLIST_LOAD_BATCH'
export const PLAYLIST_LOAD_PLAIN_UPDATE = 'PLAYLIST_LOAD_PLAIN_UPDATE'
export const PLAYLIST_SHARE = 'PLAYLIST_SHARE'
export const PLAYLIST_SHARE_SUCCESS = 'PLAYLIST_SHARE_SUCCESS'
export const PLAYLIST_SHARE_ERROR = 'PLAYLIST_SHARE_ERROR'
export const PLAYLIST_SHARES_LOADING = 'PLAYLIST_SHARES_LOADING'
export const PLAYLIST_SHARES_LOADING_SUCCESS = 'PLAYLIST_SHARES_LOADING_SUCCESS'
export const PLAYLIST_SHARES_LOADING_ERROR = 'PLAYLIST_SHARES_LOADING_ERROR'
export const PLAYLIST_ATTACH_TRACKS = 'PLAYLIST_ATTACH_TRACKS'
export const PLAYLIST_ACTION_STATUS_SET = 'PLAYLIST_ACTION_STATUS_SET'
export const PLAYLIST_LOAD_STATS = 'PLAYLIST_LOAD_STATS'
export const PLAYLIST_LOAD_STATS_SUCCESS = 'PLAYLIST_LOAD_STATS_SUCCESS'
export const PLAYLIST_LOAD_STATS_ERROR = 'PLAYLIST_LOAD_STATS_ERROR'
export const PLAYLIST_LOAD_ZIP_URLS = 'PLAYLIST_LOAD_ZIP_URLS'
export const PLAYLIST_LOAD_ZIP_URLS_SUCCESS = 'PLAYLIST_LOAD_ZIP_URLS_SUCCESS'
export const PLAYLIST_LOAD_ZIP_URLS_FAIL = 'PLAYLIST_LOAD_ZIP_URLS_FAIL'
export const PLAYLIST_LOAD_PARAMS = 'PLAYLIST_LOAD_PARAMS'
export const PLAYLIST_LOAD = 'PLAYLIST_LOAD'
export const PLAYLIST_LOAD_SUCCESS = 'PLAYLIST_LOAD_SUCCESS'
export const PLAYLIST_LOAD_FAIL = 'PLAYLIST_LOAD_FAIL'
export const PLAYLIST_UPDATE = 'PLAYLIST_UPDATE'
export const PLAYLIST_UPDATE_SUCCESS = 'PLAYLIST_UPDATE_SUCCESS'
export const PLAYLIST_UPDATE_FAIL = 'PLAYLIST_UPDATE_FAIL'
export const PLAYLISTS_LOAD_NEXT = 'PLAYLISTS_LOAD_NEXT'
export const PLAYLISTS_LOAD_NEXT_SUCCESS = 'PLAYLISTS_LOAD_NEXT_SUCCESS'
export const PLAYLISTS_LOAD_NEXT_FAIL = 'PLAYLISTS_LOAD_NEXT_FAIL'
export const PLAYLISTS_SEARCH = 'PLAYLISTS_SEARCH'
export const PLAYLISTS_SEARCH_SUCCESS = 'PLAYLISTS_SEARCH_SUCCESS'
export const PLAYLISTS_SEARCH_FAIL = 'PLAYLISTS_SEARCH_FAIL'
export const PLAYLISTS_UPDATE = 'PLAYLISTS_UPDATE'
export const PLAYLISTS_UPDATE_SUCCESS = 'PLAYLISTS_UPDATE_SUCCESS'
export const PLAYLISTS_UPDATE_FAIL = 'PLAYLISTS_UPDATE_FAIL'
export const PLAYLISTS_CURATED_LOAD = 'PLAYLISTS_CURATED_LOAD'
export const PLAYLISTS_CURATED_LOAD_SUCCESS = 'PLAYLISTS_CURATED_LOAD_SUCCESS'
export const PLAYLISTS_CURATED_LOAD_FAIL = 'PLAYLISTS_CURATED_LOAD_FAIL'
export const REFERRAL_INVITE = 'REFERRAL_INVITE'
export const REFERRAL_INVITE_SUCCESS = 'REFERRAL_INVITE_SUCCESS'
export const REFERRAL_INVITE_ERROR = 'REFERRAL_INVITE_ERROR'
export const SHORTLIST_PLAYLIST_TRACKS_ADD = 'SHORTLIST_PLAYLIST_TRACKS_ADD'
export const SHORTLIST_UPDATE = 'SHORTLIST_UPDATE'
export const SHORTLIST_NEW_START_CREATE = 'SHORTLIST_NEW_START_CREATE'
export const SHORTLIST_NEW = 'SHORTLIST_NEW'
export const SHORTLIST_DELETE = 'SHORTLIST_DELETE'
export const SHORTLIST_CLEAR = 'SHORTLIST_CLEAR'
export const SHORTLIST_RESET = 'SHORTLIST_RESET'
export const SHORTLIST_UPLOADS_CANCEL = 'SHORTLIST_UPLOADS_CANCEL'
export const SHORTLIST_TEMP_ITEM_UPDATE = 'SHORTLIST_TEMP_ITEM_UPDATE'
export const SHORTLIST_TEMP_ITEM_INSERT = 'SHORTLIST_TEMP_ITEM_INSERT'
export const SHORTLIST_TEMP_ITEM_REMOVE = 'SHORTLIST_TEMP_ITEM_REMOVE'
export const SHORTLIST_SECTION_ADD = 'SHORTLIST_SECTION_ADD'
export const SHORTLIST_SECTION_UPDATE = 'SHORTLIST_SECTION_UPDATE'
export const SHORTLIST_SECTION_REMOVE = 'SHORTLIST_SECTION_REMOVE'
export const SHORTLIST_SET_LOADING = 'SHORTLIST_SET_LOADING'
export const SHORTLIST_ACTIVATE = 'SHORTLIST_ACTIVATE'
export const SHORTLIST_DEACTIVATE = 'SHORTLIST_DEACTIVATE'
export const SHORTLIST_TEMP_ITEM_PROGRESS_UPDATE =
  'SHORTLIST_TEMP_ITEM_PROGRESS_UPDATE'
export const TRACKS_UPLOADER_SET = 'TRACKS_UPLOADER_SET'
export const TRACKS_UPLOADER_UPLOAD_SUCCESS = 'TRACKS_UPLOADER_UPLOAD_SUCCESS'
export const TRACKS_UPLOADER_RESET = 'TRACKS_UPLOADER_RESET'
export const TRACKS_UPLOADER_SAVE_SUCCESS = 'TRACKS_UPLOADER_SAVE_SUCCESS'
export const BULK_SELECT_TRACK = 'BULK_SELECT_TRACK'
export const BULK_DESELECT_TRACK = 'BULK_DESELECT_TRACK'
export const BULK_SELECT_ALL = 'BULK_SELECT_ALL'
export const BULK_DESELECT_ALL = 'BULK_DESELECT_ALL'
export const USER_AUTOLOGIN = 'USER_AUTOLOGIN'
export const USER_AUTOLOGIN_SUCCESS = 'USER_AUTOLOGIN_SUCCESS'
export const USER_AUTOLOGIN_ERROR = 'USER_AUTOLOGIN_ERROR'
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_ERROR_CLEAR = 'USER_LOGIN_ERROR_CLEAR'
export const USER_LOGIN_REQUIRE_MFA = 'USER_LOGIN_REQUIRE_MFA'
export const USER_LOGIN_REQUIRE_BUSINESS_SELECT =
  'USER_LOGIN_REQUIRE_BUSINESS_SELECT'
export const USER_BUSINESS_LIST_RESET = 'USER_BUSINESS_LIST_RESET'
export const USER_UPDATED_MOBILE_BUSINESS_LIST =
  'USER_UPDATED_MOBILE_BUSINESS_LIST'
export const USER_SETTINGS_UPDATE = 'USER_SETTINGS_UPDATE'
export const USER_SETTINGS_UPDATE_SUCCESS = 'USER_SETTINGS_UPDATE_SUCCESS'
export const USER_SETTINGS_UPDATE_FAIL = 'USER_SETTINGS_UPDATE_FAIL'
export const USER_PASSWORD_CHANGE = 'USER_PASSWORD_CHANGE'
export const USER_PASSWORD_CHANGE_SUCCESS = 'USER_PASSWORD_CHANGE_SUCCESS'
export const USER_PASSWORD_CHANGE_FAIL = 'USER_PASSWORD_CHANGE_FAIL'
export const USER_URL_CHECK = 'USER_URL_CHECK'
export const USER_URL_CHECK_SUCCESS = 'USER_URL_CHECK_SUCCESS'
export const USER_URL_CHECK_FAIL = 'USER_URL_CHECK_FAIL'
export const USER_CLEAR_MFA_STATE = 'USER_CLEAR_MFA_STATE'
export const BUSINESS_SETTINGS_UPDATE = 'BUSINESS_SETTINGS_UPDATE'
export const BUSINESS_SETTINGS_UPDATE_PROGRESS =
  'BUSINESS_SETTINGS_UPDATE_PROGRESS'
export const BUSINESS_SETTINGS_UPDATE_SUCCESS =
  'BUSINESS_SETTINGS_UPDATE_SUCCESS'
export const BUSINESS_SETTINGS_UPDATE_FAIL = 'BUSINESS_SETTINGS_UPDATE_FAIL'
export const BUSINESS_DATA_LOAD = 'BUSINESS_DATA_LOAD'
export const BUSINESS_SETTINGS_LOAD = 'BUSINESS_SETTINGS_LOAD'
export const BUSINESS_SWITCH = 'BUSINESS_SWITCH'
export const SUBSCRIPTION_LOAD = 'SUBSCRIPTION_LOAD'
export const SUBSCRIPTION_LOAD_FAIL = 'SUBSCRIPTION_LOAD_FAIL'
export const SUBSCRIPTION_LOAD_SUCCESS = 'SUBSCRIPTION_LOAD_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const SIDEBAR_OPEN = 'SIDEBAR_OPEN'
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE'
export const LIBRARY_SELECT = 'LIBRARY_SELECT'
export const LIBRARY_USER_DEFAULT_LOAD = 'LIBRARY_USER_DEFAULT_LOAD'
export const WINDOW_RESIZE = 'WINDOW_RESIZE'
export const IMPORTANT_UPDATE_AVAILABLE = 'IMPORTANT_UPDATE_AVAILABLE'
export const SHORTLISTS_TOGGLE = 'SHORTLISTS_TOGGLE'
export const FOCUS_ON_EXPLORER = 'FOCUS_ON_EXPLORER'
export const PRELOAD_DATA_ON_LOGIN = 'PRELOAD_DATA_ON_LOGIN'
export const USER_PRELOADED = 'USER_PRELOADED'
export const SEARCH_PARAMS_UPDATE = 'SEARCH_PARAMS_UPDATE'
export const INBOX_SEARCH_PARAMS_UPDATE = 'INBOX_SEARCH_PARAMS_UPDATE'
export const SEARCH_QUERY = 'SEARCH_QUERY'
export const SEARCH_QUERY_SUCCESS = 'SEARCH_QUERY_SUCCESS'
export const SEARCH_QUERY_FAIL = 'SEARCH_QUERY_FAIL'
export const SEARCH_ADD_METADATA_FILTER = 'SEARCH_ADD_METADATA_FILTER'
export const SEARCH_REMOVE_METADATA_FILTER = 'SEARCH_REMOVE_METADATA_FILTER'
export const SEARCH_CLEAR = 'SEARCH_CLEAR'
export const SEARCH_HISTORY_APPEND = 'SEARCH_HISTORY_APPEND'
export const SEARCH_RESULTS_CACHE_SET = 'SEARCH_RESULTS_CACHE_SET'
export const BROWSE_VIEW_CACHE_CLEAR = 'BROWSE_VIEW_CACHE_CLEAR'
export const BROWSE_CONTENT_CHANGED = 'BROWSE_CONTENT_CHANGED'
export const CHANNELS_SEARCH_QUERY = 'CHANNELS_SEARCH_QUERY'
export const AGGREGATED_SEARCH_QUERY = 'AGGREGATED_SEARCH_QUERY'
export const AGGREGATED_SEARCH_QUERY_SUCCESS = 'AGGREGATED_SEARCH_QUERY_SUCCESS'
export const AGGREGATED_SEARCH_QUERY_FAIL = 'AGGREGATED_SEARCH_QUERY_FAIL'
export const AGGREGATED_SEARCH_QUERY_NEXT_PAGE =
  'AGGREGATED_SEARCH_QUERY_NEXT_PAGE'
export const AGGREGATED_SEARCH_QUERY_NEXT_PAGE_SUCCESS =
  'AGGREGATED_SEARCH_QUERY_NEXT_PAGE_SUCCESS'
export const AGGREGATED_SEARCH_QUERY_NEXT_PAGE_FAIL =
  'AGGREGATED_SEARCH_QUERY_NEXT_PAGE_FAIL'
export const CHANNEL_SHARE_NOTIFICATION_RECEIVE =
  'CHANNEL_SHARE_NOTIFICATION_RECEIVE'
export const CHANNEL_SHARE_NOTIFICATION_ACCEPTED =
  'CHANNEL_SHARE_NOTIFICATION_ACCEPTED'
export const PLAYLIST_NOTIFICATION_RECEIVE = 'PLAYLIST_NOTIFICATION_RECEIVE'
export const BRIEF_SUBMISSION_NOTIFICATION_RECEIVE =
  'BRIEF_SUBMISSION_NOTIFICATION_RECEIVE'
export const MENTION_NOTIFICATION_RECEIVE = 'MENTION_NOTIFICATION_RECEIVE'
export const REACTION_NOTIFICATION_RECEIVE = 'REACTION_NOTIFICATION_RECEIVE'
export const REPLY_NOTIFICATION_RECEIVE = 'REPLY_NOTIFICATION_RECEIVE'
export const PLAYLIST_NOTIFICATION_RESET = 'PLAYLIST_NOTIFICATION_RESET'
export const PLAYLIST_NOTIFICATIONS_BATCH_LOAD =
  'PLAYLIST_NOTIFICATIONS_BATCH_LOAD'
export const UI_NOTIFICATION_PUSH = 'UI_NOTIFICATION_PUSH'
export const CONTACT_EMAIL_GROUPS_LOAD = 'CONTACT_EMAIL_GROUPS_LOAD'
export const CONTACT_EMAIL_GROUPS_LOAD_SUCCESS =
  'CONTACT_EMAIL_GROUPS_LOAD_SUCCESS'
export const CONTACT_EMAIL_GROUPS_LOAD_FAIL = 'CONTACT_EMAIL_GROUPS_LOAD_FAIL'
export const EMAIL_GROUPS_LOAD = 'EMAIL_GROUPS_LOAD'
export const EMAIL_GROUPS_LOAD_SUCCESS = 'EMAIL_GROUPS_LOAD_SUCCESS'
export const EMAIL_GROUPS_LOAD_FAIL = 'EMAIL_GROUPS_LOAD_FAIL'
export const MAILING_LIST_LOAD = 'MAILING_LIST_LOAD'
export const MAILING_LIST_LOAD_SUCCESS = 'MAILING_LIST_LOAD_SUCCESS'
export const MAILING_LIST_LOAD_FAIL = 'MAILING_LIST_LOAD_FAIL'
export const EMAIL_GROUP_GET = 'EMAIL_GROUP_GET'
export const EMAIL_GROUP_GET_SUCCESS = 'EMAIL_GROUP_GET_SUCCESS'
export const EMAIL_GROUP_GET_FAIL = 'EMAIL_GROUP_GET_FAIL'
export const EMAIL_GROUP_CREATE = 'EMAIL_GROUP_CREATE'
export const EMAIL_GROUP_CREATE_SUCCESS = 'EMAIL_GROUP_CREATE_SUCCESS'
export const EMAIL_GROUP_CREATE_FAIL = 'EMAIL_GROUP_CREATE_FAIL'
export const EMAIL_GROUP_UPDATE = 'EMAIL_GROUP_UPDATE'
export const EMAIL_GROUP_UPDATE_SUCCESS = 'EMAIL_GROUP_UPDATE_SUCCESS'
export const EMAIL_GROUP_UPDATE_FAIL = 'EMAIL_GROUP_UPDATE_FAIL'
export const EMAIL_GROUP_DELETE = 'EMAIL_GROUP_DELETE'
export const EMAIL_GROUP_DELETE_SUCCESS = 'EMAIL_GROUP_DELETE_SUCCESS'
export const EMAIL_GROUP_DELETE_FAIL = 'EMAIL_GROUP_DELETE_FAIL'
export const GROUPS_LOAD = 'GROUPS_LOAD'
export const GROUPS_LOAD_SUCCESS = 'GROUPS_LOAD_SUCCESS'
export const GROUPS_LOAD_FAIL = 'GROUPS_LOAD_FAIL'
export const GROUP_GET = 'GROUP_GET'
export const GROUP_GET_SUCCESS = 'GROUP_GET_SUCCESS'
export const GROUP_GET_FAIL = 'GROUP_GET_FAIL'
export const GROUP_CREATE = 'GROUP_CREATE'
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS'
export const GROUP_CREATE_FAIL = 'GROUP_CREATE_FAIL'
export const GROUP_UPDATE = 'GROUP_UPDATE'
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS'
export const GROUP_UPDATE_FAIL = 'GROUP_UPDATE_FAIL'
export const GROUP_DELETE = 'GROUP_DELETE'
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS'
export const GROUP_DELETE_FAIL = 'GROUP_DELETE_FAIL'
export const LOAD_GROUP_BUSINESS_INVITES = 'LOAD_GROUP_BUSINESS_INVITES'
export const LOAD_GROUP_BUSINESS_INVITES_SUCCESS =
  'LOAD_GROUP_BUSINESS_INVITES_SUCCESS'
export const LOAD_GROUP_BUSINESS_INVITES_FAIL =
  'LOAD_GROUP_BUSINESS_INVITES_FAIL'
export const GROUP_BUSINESS_INVITE = 'GROUP_BUSINESS_INVITE'
export const GROUP_BUSINESS_INVITE_SUCCESS = 'GROUP_BUSINESS_INVITE_SUCCESS'
export const GROUP_BUSINESS_INVITE_FAIL = 'GROUP_BUSINESS_INVITE_FAIL'
export const GROUP_BUSINESS_INVITE_RESEND = 'GROUP_BUSINESS_INVITE_RESEND'
export const GROUP_BUSINESS_INVITE_RESEND_SUCCESS =
  'GROUP_BUSINESS_INVITE_RESEND_SUCCESS'
export const GROUP_BUSINESS_INVITE_RESEND_FAIL =
  'GROUP_BUSINESS_INVITE_RESEND_FAIL'
export const GROUP_BUSINESS_INVITE_REMOVE = 'GROUP_BUSINESS_INVITE_REMOVE'
export const GROUP_BUSINESS_INVITE_REMOVE_SUCCESS =
  'GROUP_BUSINESS_INVITE_REMOVE_SUCCESS'
export const GROUP_BUSINESS_INVITE_REMOVE_FAIL =
  'GROUP_BUSINESS_INVITE_REMOVE_FAIL'
export const GROUP_BUSINESS_SHARE_UPDATE = 'GROUP_BUSINESS_SHARE_UPDATE'
export const GROUP_BUSINESS_SHARE_UPDATE_SUCCESS =
  'GROUP_BUSINESS_SHARE_UPDATE_SUCCESS'
export const LOAD_GROUP_BUSINESS_SHARES = 'LOAD_GROUP_BUSINESS_SHARES'
export const LOAD_GROUP_BUSINESS_SHARES_SUCCESS =
  'LOAD_GROUP_BUSINESS_SHARES_SUCCESS'

export const NOTIFICATION_PANE_TOGGLE = 'NOTIFICATION_PANE_TOGGLE'
export const NOTIFICATION_PANE_EXPAND = 'NOTIFICATION_PANE_EXPAND'
export const NOTIFICATION_PANE_DISMISS = 'NOTIFICATION_PANE_DISMISS'
// forms
export const FORM_PLAYLIST_SHARE_RESET = 'FORM_PLAYLIST_SHARE_RESET'
export const FORM_PLAYLIST_SHARE_UPDATE = 'FORM_PLAYLIST_SHARE_UPDATE'
export const FORM_REFERRAL_INVITE_RESET = 'FORM_REFERRAL_INVITE_RESET'
export const FORM_REFERRAL_INVITE_UPDATE = 'FORM_REFERRAL_INVITE_UPDATE'
export const FORM_TRACK_MERGE_RESET = 'FORM_TRACK_MERGE_RESET'
export const FORM_TRACK_MERGE_CONFIRM = 'FORM_TRACK_MERGE_CONFIRM'
export const FORM_TRACK_MERGE_SELECT_ORIGINAL_FORMAT =
  'FORM_TRACK_MERGE_SELECT_ORIGINAL_FORMAT'
export const FORM_CHANNEL_SHARE_RESET = 'FORM_CHANNEL_SHARE_RESET'
export const FORM_CHANNEL_SHARE_UPDATE = 'FORM_CHANNEL_SHARE_UPDATE'
// events
export const EVENT_LOAD_BATCH = 'EVENT_LOAD_BATCH'
export const EVENT_SEND = 'EVENT_SEND'
// reports
export const REPORT_PLAYLIST_PARAMS_RESET = 'REPORT_PLAYLIST_PARAMS_RESET'
export const REPORT_PLAYLIST_PARAMS_UPDATE = 'REPORT_PLAYLIST_PARAMS_UPDATE'
export const REPORT_PLAYLIST_GENERATE = 'REPORT_PLAYLIST_GENERATE'
export const REPORT_PLAYLIST_GENERATE_SUCCESS =
  'REPORT_PLAYLIST_GENERATE_SUCCESS'
export const REPORT_PLAYLIST_GENERATE_ERROR = 'REPORT_PLAYLIST_GENERATE_ERROR'
export const REPORT_PLAYLIST_FILTER_TOGGLE = 'REPORT_PLAYLIST_FILTER_TOGGLE'
export const REPORT_PLAYLIST_SECTION_TOGGLE = 'REPORT_PLAYLIST_SECTION_TOGGLE'
export const REPORT_PLAYLIST_COLUMN_TOGGLE = 'REPORT_PLAYLIST_COLUMN_TOGGLE'
export const REPORT_PLAYLIST_COLUMN_CUSTOM_FIELD_TOGGLE =
  'REPORT_PLAYLIST_COLUMN_CUSTOM_FIELD_TOGGLE'
// analytics (stats)
export const STATS_CHANGE_MODE = 'STATS_CHANGE_MODE'
export const STATS_PARAMS_RESET = 'STATS_PARAMS_RESET'
export const STATS_PARAMS_UPDATE = 'STATS_PARAMS_UPDATE'
export const STATS_CHART_LOAD = 'STATS_CHART_LOAD'
export const STATS_CHART_LOAD_SUCCESS = 'STATS_CHART_LOAD_SUCCESS'
export const STATS_CHART_LOAD_FAIL = 'STATS_CHART_LOAD_FAIL'
export const STATS_SUMMARY_LOAD = 'STATS_SUMMARY_LOAD'
export const STATS_SUMMARY_LOAD_SUCCESS = 'STATS_SUMMARY_LOAD_SUCCESS'
export const STATS_SUMMARY_LOAD_FAIL = 'STATS_SUMMARY_LOAD_FAIL'
export const STATS_LOAD = 'STATS_LOAD'
export const STATS_LOAD_SUCCESS = 'STATS_LOAD_SUCCESS'
export const STATS_LOAD_FAIL = 'STATS_LOAD_FAIL'
// analytics events
export const ANALYTICS_EVENT_SEND = 'ANALYTICS_EVENT_SEND'
// selection
export const ADD_EMPTY_SELECTION = 'ADD_EMPTY_SELECTION'
export const REMOVE_DATA_TABLE_SELECTION = 'REMOVE_DATA_TABLE_SELECTION'
export const REMOVE_SELECTION = 'REMOVE_SELECTION'
export const SELECTION_CHANGE = 'SELECTION_CHANGE'
export const SELECTION_RESET = 'SELECTION_RESET'
export const UPDATE_SELECTION_ITEMS = 'UPDATE_SELECTION_ITEMS'
export const TAGS_LOAD_SUCCESS = 'TAGS_LOAD_SUCCESS'
export const TAGS_LOAD_ERROR = 'TAGS_LOAD_ERROR'
export const NATIVE_TAGS_EDIT = 'NATIVE_TAGS_EDIT'
export const PLAYLIST_TAGS_EDIT = 'PLAYLIST_TAGS_EDIT'
export const CONTACTS_LOAD = 'CONTACTS_LOAD'
export const CONTACTS_LOAD_FAIL = 'CONTACTS_LOAD_FAIL'
export const CONTACTS_LOAD_SUCCESS = 'CONTACTS_LOAD_SUCCESS'
export const CONTACTS_LOAD_IDS = 'CONTACTS_LOAD_IDS'
export const CONTACTS_LOAD_IDS_SUCCESS = 'CONTACTS_LOAD_IDS_SUCCESS'
export const CONTACTS_LOAD_IDS_FAIL = 'CONTACTS_LOAD_IDS_FAIL'
export const CONTACTS_LOAD_IDS_NEXT_SUCCESS = 'CONTACTS_LOAD_IDS_NEXT_SUCCESS'
export const CONTACTS_LOAD_ALL = 'CONTACTS_LOAD_ALL'
export const CONTACTS_LOAD_ALL_SUCCESS = 'CONTACTS_LOAD_ALL_SUCCESS'
export const CONTACTS_LOAD_ALL_FAIL = 'CONTACTS_LOAD_ALL_FAIL'
export const CONTACTS_SORT = 'CONTACTS_SORT'
export const CONTACTS_ADD_LIST = 'CONTACTS_ADD_LIST'
export const CONTACTS_ADD_LIST_SUCCESS = 'CONTACTS_ADD_LIST_SUCCESS'
export const CONTACTS_ADD_LIST_FAIL = 'CONTACTS_ADD_LIST_FAIL'
export const CONTACTS_REMOVE_LIST = 'CONTACTS_REMOVE_LIST'
export const CONTACTS_REMOVE_LIST_SUCCESS = 'CONTACTS_REMOVE_LIST_SUCCESS'
export const CONTACTS_REMOVE_LIST_FAIL = 'CONTACTS_REMOVE_LIST_FAIL'
export const CONTACTS_CREATE = 'CONTACTS_CREATE'
export const CONTACTS_CREATE_FAIL = 'CONTACTS_CREATE_FAIL'
export const CONTACTS_CREATE_SUCCESS = 'CONTACTS_CREATE_SUCCESS'
export const CONTACTS_DELETE = 'CONTACTS_DELETE'
export const CONTACTS_DELETE_FAIL = 'CONTACTS_DELETE_FAIL'
export const CONTACTS_DELETE_SUCCESS = 'CONTACTS_DELETE_SUCCESS'
export const CONTACTS_SET_COLUMN_MAPPING = 'CONTACTS_SET_COLUMN_MAPPING'
export const CONTACTS_SEARCH = 'CONTACTS_SEARCH'
export const CONTACTS_MODE_SWITCH = 'CONTACTS_MODE_SWITCH'
export const CONTACTS_VALUE_CHANGE = 'CONTACTS_VALUE_CHANGE'
export const CONTACTS_UPDATE = 'CONTACTS_UPDATE'
export const CONTACTS_UPDATE_SUCCESS = 'CONTACTS_UPDATE_SUCCESS'
export const CONTACTS_UPDATE_FAIL = 'CONTACTS_UPDATE_FAIL'
export const CONTACTS_UPDATE_ALL_SUCCESS = 'CONTACTS_UPDATE_ALL_SUCCESS'
export const CONTACTS_UNSUBSCRIBE_SUCCESS = 'CONTACTS_UNSUBSCRIBE_SUCCESS'
export const CONTACTS_UNSUBSCRIBE_FAIL = 'CONTACTS_UNSUBSCRIBE_FAIL'
export const CONTACTS_IMPORT = 'CONTACTS_IMPORT'
export const CONTACTS_IMPORT_SUCCESS = 'CONTACTS_IMPORT_SUCCESS'
export const CONTACTS_IMPORT_FAIL = 'CONTACTS_IMPORT_FAIL'
export const CONTACTS_UPDATE_TAGS = 'CONTACTS_UPDATE_TAGS'
export const CONTACTS_UPDATE_TAGS_SUCCESS = 'CONTACTS_UPDATE_TAGS_SUCCESS'
export const CONTACTS_UPDATE_TAGS_FAIL = 'CONTACTS_UPDATE_TAGS_FAIL'
export const CONTACTS_VALUE_ADD = 'CONTACTS_VALUE_ADD'
export const CONTACTS_VALUE_REMOVE = 'CONTACTS_VALUE_REMOVE'
export const CONTACT_ACTIVITY_LOAD = 'CONTACT_ACTIVITY_LOAD'
export const CONTACT_ACTIVITY_LOAD_SUCCESS = 'CONTACT_ACTIVITY_LOAD_SUCCESS'
export const CONTACT_ACTIVITY_LOAD_FAIL = 'CONTACT_ACTIVITY_LOAD_FAIL'
export const CONTACT_NOTES_CREATE = 'CONTACT_NOTES_CREATE'
export const CONTACT_NOTES_CREATE_SUCCESS = 'CONTACT_NOTES_CREATE_SUCCESS'
export const CONTACT_NOTES_CREATE_FAIL = 'CONTACT_NOTES_CREATE_FAIL'
export const CONTACT_NOTES_DELETE = 'CONTACT_NOTES_DELETE'
export const CONTACT_NOTES_DELETE_SUCCESS = 'CONTACT_NOTES_DELETE_SUCCESS'
export const CONTACT_NOTES_DELETE_FAIL = 'CONTACT_NOTES_DELETE_FAIL'
export const CONTACT_NOTES_UPDATE = 'CONTACT_NOTES_UPDATE'
export const CONTACT_NOTES_UPDATE_SUCCESS = 'CONTACT_NOTES_UPDATE_SUCCESS'
export const CONTACT_NOTES_UPDATE_FAIL = 'CONTACT_NOTES_UPDATE_FAIL'
export const CONTACT_NOTES_LOAD = 'CONTACT_NOTES_LOAD'
export const CONTACT_NOTES_LOAD_SUCCESS = 'CONTACT_NOTES_LOAD_SUCCESS'
export const CONTACT_NOTES_LOAD_FAIL = 'CONTACT_NOTES_LOAD_FAIL'
export const CONTACTS_TOGGLE = 'CONTACTS_TOGGLE'
export const CONTACTS_CANCEL_EDITING = 'CONTACTS_CANCEL_EDITING'
export const CONTACTS_ADD_WARNING = 'CONTACTS_ADD_WARNING'
export const CONTACTS_REMOVE_WARNING = 'CONTACTS_REMOVE_WARNING'
export const PRO_ADD_SUCCESS = 'PRO_ADD_SUCCESS'
export const LABEL_ADD_SUCCESS = 'LABEL_ADD_SUCCESS'
export const LABEL_UPDATE_SUCCESS = 'LABEL_UPDATE_SUCCESS'
export const RIGHTSHOLDER_ADD_SUCCESS = 'RIGHTSHOLDER_ADD_SUCCESS'
export const RIGHTSHOLDER_UPDATE_SUCCESS = 'RIGHTSHOLDER_UPDATE_SUCCESS'
export const PRO_UPDATE_SUCCESS = 'PRO_UPDATE_SUCCESS'
export const PUBLISHERS_ADD_SUCCESS = 'PUBLISHERS_ADD_SUCCESS'
export const PUBLISHERS_UPDATE_SUCCESS = 'PUBLISHERS_UPDATE_SUCCESS'
export const BUSINESS_USERS_LOAD = 'BUSINESS_USERS_LOAD'
export const BUSINESS_USERS_LOAD_SUCCESS = 'BUSINESS_USERS_LOAD_SUCCESS'
export const BUSINESS_USERS_LOAD_FAIL = 'BUSINESS_USERS_LOAD_FAIL'
export const BUSINESS_USERS_CHANGE = 'BUSINESS_USERS_CHANGE'
export const BUSINESS_USERS_CHANGE_SUCCESS = 'BUSINESS_USERS_CHANGE_SUCCESS'
export const BUSINESS_USERS_CHANGE_FAIL = 'BUSINESS_USERS_CHANGE_FAIL'
export const BUSINESS_USERS_REMOVE = 'BUSINESS_USERS_REMOVE'
export const BUSINESS_USERS_REMOVE_SUCCESS = 'BUSINESS_USERS_REMOVE_SUCCESS'
export const BUSINESS_USERS_REMOVE_FAIL = 'BUSINESS_USERS_REMOVE_FAIL'
export const BUSINESS_INVITE_LOAD = 'BUSINESS_INVITE_LOAD'
export const BUSINESS_INVITE_LOAD_SUCCESS = 'BUSINESS_INVITE_LOAD_SUCCESS'
export const BUSINESS_INVITE_LOAD_FAIL = 'BUSINESS_INVITE_LOAD_FAIL'
export const BUSINESS_INVITE_SEND = 'BUSINESS_INVITE_SEND'
export const BUSINESS_INVITE_SEND_SUCCESS = 'BUSINESS_INVITE_SEND_SUCCESS'
export const BUSINESS_INVITE_SEND_FAIL = 'BUSINESS_INVITE_SEND_FAIL'
export const BUSINESS_INVITE_RESEND = 'BUSINESS_INVITE_RESEND'
export const BUSINESS_INVITE_RESEND_SUCCESS = 'BUSINESS_INVITE_RESEND_SUCCESS'
export const BUSINESS_INVITE_RESEND_FAIL = 'BUSINESS_INVITE_RESEND_FAIL'
export const BUSINESS_INVITE_CANCEL = 'BUSINESS_INVITE_CANCEL'
export const BUSINESS_INVITE_CANCEL_SUCCESS = 'BUSINESS_INVITE_CANCEL_SUCCESS'
export const BUSINESS_INVITE_CANCEL_FAIL = 'BUSINESS_INVITE_CANCEL_FAIL'
export const PLAN_UPDATE_LOAD = 'PLAN_UPDATE_LOAD'
export const DATA_LOAD = 'DATA_LOAD'
// public pages
export const LOAD_PLAYLIST_PAGE_SUCCESS = 'LOAD_PLAYLIST_PAGE_SUCCESS'
export const ADD_TO_DISCO = 'ADD_TO_DISCO'
export const ADD_TO_DISCO_CHOOSE_BUSINESS = 'ADD_TO_DISCO_CHOOSE_BUSINESS'
export const ADD_TO_DISCO_CHOOSE_CANCEL = 'ADD_TO_DISCO_CHOOSE_CANCEL'
export const ADD_TO_DISCO_SUCCESS = 'ADD_TO_DISCO_SUCCESS'
export const ADD_TO_DISCO_ERROR = 'ADD_TO_DISCO_ERROR'
export const LIST_FORM_START_MANAGING_LISTS = 'LIST_FORM_START_MANAGING_LISTS'
export const LIST_FORM_SAVE = 'LIST_FORM_SAVE'
export const LIST_FORM_SAVE_SUCCESS = 'LIST_FORM_SAVE_SUCCESS'
export const LIST_FORM_SAVE_ERROR = 'LIST_FORM_SAVE_ERROR'
export const LIST_FORM_DELETE = 'LIST_FORM_DELETE'
export const LIST_FORM_CLOSE = 'LIST_FORM_CLOSE'
export const LIST_BUSINESS_FORM_DONE = 'LIST_BUSINESS_FORM_DONE'
export const LIST_FORM_INCLUDE_BUSINESS = 'LIST_FORM_INCLUDE_BUSINESS'
export const LIST_FORM_MODIFY_LISTS = 'LIST_FORM_MODIFY_LISTS'
export const CAMPAIGN_LIST_GET_ALL = 'CAMPAIGN_LIST_GET_ALL'
export const CAMPAIGN_LIST_GET_ALL_SUCCESS = 'CAMPAIGN_LIST_GET_ALL_SUCCESS'
export const CAMPAIGN_LIST_GET_ALL_FAIL = 'CAMPAIGN_LIST_GET_ALL_FAIL'
export const CAMPAIGN_LIST_GET = 'CAMPAIGN_LIST_GET'
export const CAMPAIGN_LIST_GET_SUCCESS = 'CAMPAIGN_LIST_GET_SUCCESS'
export const CAMPAIGN_LIST_GET_FAIL = 'CAMPAIGN_LIST_GET_FAIL'
export const CAMPAIGN_LIST_FILTER = 'CAMPAIGN_LIST_FILTER'
export const CAMPAIGN_LIST_BEGIN_CREATING = 'CAMPAIGN_LIST_BEGIN_CREATING'
export const CAMPAIGN_LIST_CANCEL_CREATING = 'CAMPAIGN_LIST_CANCEL_CREATING'
export const CAMPAIGN_LIST_MODAL_UPDATE = 'CAMPAIGN_LIST_MODAL_UPDATE'
export const CAMPAIGN_LIST_CREATE = 'CAMPAIGN_LIST_CREATE'
export const CAMPAIGN_LIST_CREATE_SUCCESS = 'CAMPAIGN_LIST_CREATE_SUCCESS'
export const CAMPAIGN_LIST_CREATE_FAIL = 'CAMPAIGN_LIST_CREATE_FAIL'
export const CAMPAIGN_LIST_DELETE = 'CAMPAIGN_LIST_DELETE'
export const CAMPAIGN_LIST_DELETE_SUCCESS = 'CAMPAIGN_LIST_DELETE_SUCCESS'
export const CAMPAIGN_LIST_DELETE_FAIL = 'CAMPAIGN_LIST_DELETE_FAIL'
export const CAMPAIGN_LIST_BEGIN_EDIT = 'CAMPAIGN_LIST_BEGIN_EDIT'
export const CAMPAIGN_DETAILS_UPDATE = 'CAMPAIGN_DETAILS_UPDATE'
export const CAMPAIGN_DETAILS_MARK_DIRTY = 'CAMPAIGN_DETAILS_MARK_DIRTY'
export const CAMPAIGN_DETAILS_SAVE = 'CAMPAIGN_DETAILS_SAVE'
export const CAMPAIGN_DETAILS_SAVE_SUCCESS = 'CAMPAIGN_DETAILS_SAVE_SUCCESS'
export const CAMPAIGN_DETAILS_SAVE_CONFLICT = 'CAMPAIGN_DETAILS_SAVE_CONFLICT'
export const CAMPAIGN_DETAILS_SAVE_FAIL = 'CAMPAIGN_DETAILS_SAVE_FAIL'
export const CAMPAIGN_DETAILS_RESOLVE_CONFLICT =
  'CAMPAIGN_DETAILS_RESOLVE_CONFLICT'
export const CAMPAIGN_SCHEDULED_TO_SEND_SUCCESS =
  'CAMPAIGN_SCHEDULED_TO_SEND_SUCCESS'
export const CAMPAIGN_SCHEDULED_TO_SEND_FAIL = 'CAMPAIGN_SCHEDULED_TO_SEND_FAIL'
export const CAMPAIGN_RESCHEDULED_SUCCESS = 'CAMPAIGN_RESCHEDULED_SUCCESS'
export const CAMPAIGN_RESCHEDULED_FAIL = 'CAMPAIGN_RESCHEDULED_FAIL'
export const CAMPAIGN_SCHEDULE_CANCELLED_SUCCESS =
  'CAMPAIGN_SCHEDULE_CANCELLED_SUCCESS'
export const CAMPAIGN_SCHEDULE_CANCELLED_FAIL =
  'CAMPAIGN_SCHEDULE_CANCELLED_FAIL'
export const CAMPAIGN_BEGIN_SENDING = 'CAMPAIGN_BEGIN_SENDING'
export const CAMPAIGN_BEGIN_SENDING_SUCCESS = 'CAMPAIGN_BEGIN_SENDING_SUCCESS'
export const CAMPAIGN_BEGIN_SENDING_FAIL = 'CAMPAIGN_BEGIN_SENDING_FAIL'
export const CAMPAIGN_RECIPIENT_MODE_SELECT = 'CAMPAIGN_RECIPIENT_MODE_SELECT'
export const CAMPAIGN_RECIPIENT_ADD = 'CAMPAIGN_RECIPIENT_ADD'
export const CAMPAIGN_RECIPIENT_REMOVE = 'CAMPAIGN_RECIPIENT_REMOVE'
export const CAMPAIGN_RECIPIENT_CHANGE = 'CAMPAIGN_RECIPIENT_CHANGE'
// campaign editor
export const CAMPAIGN_EDITOR_DUPLICATE_SECTION =
  'CAMPAIGN_EDITOR_DUPLICATE_SECTION'
export const CAMPAIGN_EDITOR_MOVE_SECTION = 'CAMPAIGN_EDITOR_MOVE_SECTION'
export const CAMPAIGN_EDITOR_DELETE_SECTION = 'CAMPAIGN_EDITOR_DELETE_SECTION'
export const CAMPAIGN_EDITOR_UPDATE_SECTION = 'CAMPAIGN_EDITOR_UPDATE_SECTION'
export const CAMPAIGN_EDITOR_INSERT_SECTION_BLOCK =
  'CAMPAIGN_EDITOR_INSERT_SECTION_BLOCK'
export const CAMPAIGN_EDITOR_TEXT_BLOCK_CHANGE =
  'CAMPAIGN_EDITOR_TEXT_BLOCK_CHANGE'
export const CAMPAIGN_EDITOR_PLAYLIST_BLOCK_CHANGE =
  'CAMPAIGN_EDITOR_PLAYLIST_BLOCK_CHANGE'
export const CAMPAIGN_EDITOR_EDIT_MODE_SWITCH =
  'CAMPAIGN_EDITOR_EDIT_MODE_SWITCH'
export const CAMPAIGN_EDITOR_LOAD = 'CAMPAIGN_EDITOR_LOAD'
export const CAMPAIGN_FOOTER_CREATE = 'CAMPAIGN_FOOTER_CREATE'
export const CAMPAIGN_FOOTER_CREATE_SUCCESS = 'CAMPAIGN_FOOTER_CREATE_SUCCESS'
export const CAMPAIGN_FOOTER_CREATE_FAIL = 'CAMPAIGN_FOOTER_CREATE_FAIL'
export const CAMPAIGN_FOOTER_DELETE = 'CAMPAIGN_FOOTER_DELETE'
export const CAMPAIGN_FOOTER_DELETE_SUCCESS = 'CAMPAIGN_FOOTER_DELETE_SUCCESS'
export const CAMPAIGN_FOOTER_DELETE_FAIL = 'CAMPAIGN_FOOTER_DELETE_FAIL'
export const CAMPAIGN_FOOTER_UPDATE = 'CAMPAIGN_FOOTER_UPDATE'
export const CAMPAIGN_FOOTER_UPDATE_SUCCESS = 'CAMPAIGN_FOOTER_UPDATE_SUCCESS'
export const CAMPAIGN_FOOTER_UPDATE_FAIL = 'CAMPAIGN_FOOTER_UPDATE_FAIL'
export const CAMPAIGN_FOOTERS_LOAD = 'CAMPAIGN_FOOTERS_LOAD'
export const CAMPAIGN_FOOTERS_LOAD_SUCCESS = 'CAMPAIGN_FOOTERS_LOAD_SUCCESS'
export const CAMPAIGN_FOOTERS_LOAD_FAIL = 'CAMPAIGN_FOOTERS_LOAD_FAIL'
export const CAMPAIGN_EDITOR_UPDATE_GLOBAL_PROPS =
  'CAMPAIGN_EDITOR_UPDATE_GLOBAL_PROPS'
export const CAMPAIGN_STATS_LOAD = 'CAMPAIGN_STATS_LOAD'
export const CAMPAIGN_STATS_LOAD_SUCCESS = 'CAMPAIGN_STATS_LOAD_SUCCESS'
export const CAMPAIGN_STATS_LOAD_FAIL = 'CAMPAIGN_STATS_LOAD_FAIL'
export const CAMPAIGN_SEARCH = 'CAMPAIGN_SEARCH'
export const SWITCH_TERRITORY_WARNING = 'SWITCH_TERRITORY_WARNING'
export const ARTISTS_LOAD = 'ARTISTS_LOAD'
export const ARTISTS_LOAD_SUCCESS = 'ARTISTS_LOAD_SUCCESS'
export const ARTISTS_LOAD_FAIL = 'ARTISTS_LOAD_FAIL'
export const ARTISTS_LOAD_NEXT = 'ARTISTS_LOAD_NEXT'
export const ARTISTS_LOAD_NEXT_SUCCESS = 'ARTISTS_LOAD_NEXT_SUCCESS'
export const ARTISTS_LOAD_NEXT_FAIL = 'ARTISTS_LOAD_NEXT_FAIL'
export const ARTISTS_LOAD_RELATED = 'ARTISTS_LOAD_RELATED'
export const ARTISTS_LOAD_RELATED_SUCCESS = 'ARTISTS_LOAD_RELATED_SUCCESS'
export const ARTISTS_LOAD_RELATED_FAIL = 'ARTISTS_LOAD_RELATED_FAIL'
export const ARTIST_LOAD = 'ARTIST_LOAD'
export const ARTIST_LOAD_SUCCESS = 'ARTIST_LOAD_SUCCESS'
export const ARTIST_LOAD_FAIL = 'ARTIST_LOAD_FAIL'
export const ARTIST_UPDATE = 'ARTIST_UPDATE'
export const ARTIST_UPDATE_SUCCESS = 'ARTIST_UPDATE_SUCCESS'
export const ARTIST_UPDATE_FAIL = 'ARTIST_UPDATE_FAIL'
export const ARTIST_IMAGE_UPDATE = 'ARTIST_IMAGE_UPDATE'
export const ARTIST_IMAGE_UPDATE_SUCCESS = 'ARTIST_IMAGE_UPDATE_SUCCESS'
export const ARTIST_IMAGE_UPDATE_FAIL = 'ARTIST_IMAGE_UPDATE_FAIL'
export const ARTIST_SHOWCASES_LOAD = 'ARTIST_SHOWCASES_LOAD'
export const ARTIST_SHOWCASES_LOAD_SUCCESS = 'ARTIST_SHOWCASES_LOAD_SUCCESS'
export const ARTIST_SHOWCASES_LOAD_FAIL = 'ARTIST_SHOWCASES_LOAD_FAIL'
export const ARTIST_TRACKS_LOAD = 'ARTIST_TRACKS_LOAD'
export const ARTIST_TRACKS_LOAD_SUCCESS = 'ARTIST_TRACKS_LOAD_SUCCESS'
export const ARTIST_TRACKS_LOAD_FAIL = 'ARTIST_TRACKS_LOAD_FAIL'
export const CLIENT_LIBRARY_LIST_GET_ALL = 'CLIENT_LIBRARY_LIST_GET_ALL'
export const CLIENT_LIBRARY_LIST_GET_ALL_SUCCESS =
  'CLIENT_LIBRARY_LIST_GET_ALL_SUCCESS'
export const CLIENT_LIBRARY_LIST_GET_ALL_FAIL =
  'CLIENT_LIBRARY_LIST_GET_ALL_FAIL'
export const CLIENT_LIBRARY_LIST_GET = 'CLIENT_LIBRARY_LIST_GET'
export const CLIENT_LIBRARY_LIST_GET_SUCCESS = 'CLIENT_LIBRARY_LIST_GET_SUCCESS'
export const CLIENT_LIBRARY_LIST_GET_FAIL = 'CLIENT_LIBRARY_LIST_GET_FAIL'
export const CLIENT_LIBRARY_LIST_CREATE = 'CLIENT_LIBRARY_LIST_CREATE'
export const CLIENT_LIBRARY_LIST_CREATE_SUCCESS =
  'CLIENT_LIBRARY_LIST_CREATE_SUCCESS'
export const CLIENT_LIBRARY_LIST_CREATE_FAIL = 'CLIENT_LIBRARY_LIST_CREATE_FAIL'
export const CLIENT_LIBRARY_LIST_DELETE = 'CLIENT_LIBRARY_LIST_DELETE'
export const CLIENT_LIBRARY_LIST_DELETE_SUCCESS =
  'CLIENT_LIBRARY_LIST_DELETE_SUCCESS'
export const CLIENT_LIBRARY_LIST_DELETE_FAIL = 'CLIENT_LIBRARY_LIST_DELETE_FAIL'
export const CLIENT_LIBRARY_UPDATE = 'CLIENT_LIBRARY_UPDATE'
export const CLIENT_LIBRARY_UPDATE_SUCCESS = 'CLIENT_LIBRARY_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_UPDATE_FAIL = 'CLIENT_LIBRARY_UPDATE_FAIL'
export const CLIENT_LIBRARY_IMAGES_UPDATE = 'CLIENT_LIBRARY_IMAGES_UPDATE'
export const CLIENT_LIBRARY_IMAGES_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_IMAGES_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_IMAGES_UPDATE_FAIL =
  'CLIENT_LIBRARY_IMAGES_UPDATE_FAIL'
export const CLIENT_LIBRARY_ALBUMS_LOAD = 'CLIENT_LIBRARY_ALBUMS_LOAD'
export const CLIENT_LIBRARY_ALBUMS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_ALBUMS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_ALBUMS_LOAD_FAIL = 'CLIENT_LIBRARY_ALBUMS_LOAD_FAIL'
export const CLIENT_LIBRARY_ALBUMS_LOAD_NEXT = 'CLIENT_LIBRARY_ALBUMS_LOAD_NEXT'
export const CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_SUCCESS =
  'CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_SUCCESS'
export const CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_FAIL =
  'CLIENT_LIBRARY_ALBUMS_LOAD_NEXT_FAIL'
export const CLIENT_LIBRARY_ALBUMS_UPDATE = 'CLIENT_LIBRARY_ALBUMS_UPDATE'
export const CLIENT_LIBRARY_ALBUMS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_ALBUMS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_ALBUMS_UPDATE_FAIL =
  'CLIENT_LIBRARY_ALBUMS_UPDATE_FAIL'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE_FAIL =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_UPDATE_FAIL'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_SET =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_SET'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_SET_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_SET_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_ALBUMS_SET_FAIL =
  'CLIENT_LIBRARY_FEATURED_ALBUMS_SET_FAIL'
export const CLIENT_LIBRARY_ARTISTS_LOAD = 'CLIENT_LIBRARY_ARTISTS_LOAD'
export const CLIENT_LIBRARY_ARTISTS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_ARTISTS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_ARTISTS_LOAD_FAIL =
  'CLIENT_LIBRARY_ARTISTS_LOAD_FAIL'
export const CLIENT_LIBRARY_ARTISTS_LOAD_NEXT =
  'CLIENT_LIBRARY_ARTISTS_LOAD_NEXT'
export const CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_SUCCESS =
  'CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_SUCCESS'
export const CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_FAIL =
  'CLIENT_LIBRARY_ARTISTS_LOAD_NEXT_FAIL'
export const CLIENT_LIBRARY_ARTIST_LOAD = 'CLIENT_LIBRARY_ARTIST_LOAD'
export const CLIENT_LIBRARY_ARTIST_LOAD_SUCCESS =
  'CLIENT_LIBRARY_ARTIST_LOAD_SUCCESS'
export const CLIENT_LIBRARY_ARTIST_LOAD_FAIL = 'CLIENT_LIBRARY_ARTIST_LOAD_FAIL'
export const CLIENT_LIBRARY_ARTIST_UPDATE = 'CLIENT_LIBRARY_ARTIST_UPDATE'
export const CLIENT_LIBRARY_ARTIST_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_ARTIST_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_ARTIST_UPDATE_FAIL =
  'CLIENT_LIBRARY_ARTIST_UPDATE_FAIL'
export const CLIENT_LIBRARY_ARTIST_TRACKS_LOAD =
  'CLIENT_LIBRARY_ARTIST_TRACKS_LOAD'
export const CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_FAIL =
  'CLIENT_LIBRARY_ARTIST_TRACKS_LOAD_FAIL'
export const CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE =
  'CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE'
export const CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE_FAIL =
  'CLIENT_LIBRARY_ARTIST_TRACKS_UPDATE_FAIL'
export const CLIENT_LIBRARY_FEATURED_ARTISTS_SET =
  'CLIENT_LIBRARY_FEATURED_ARTISTS_SET'
export const CLIENT_LIBRARY_FEATURED_ARTISTS_SET_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_ARTISTS_SET_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_ARTISTS_SET_FAIL =
  'CLIENT_LIBRARY_FEATURED_ARTISTS_SET_FAIL'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD = 'CLIENT_LIBRARY_PLAYLISTS_LOAD'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_PLAYLISTS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD_FAIL =
  'CLIENT_LIBRARY_PLAYLISTS_LOAD_FAIL'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT =
  'CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_SUCCESS =
  'CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_SUCCESS'
export const CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_FAIL =
  'CLIENT_LIBRARY_PLAYLISTS_LOAD_NEXT_FAIL'
export const CLIENT_LIBRARY_PLAYLISTS_UPDATE = 'CLIENT_LIBRARY_PLAYLISTS_UPDATE'
export const CLIENT_LIBRARY_PLAYLISTS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_PLAYLISTS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_PLAYLISTS_UPDATE_FAIL =
  'CLIENT_LIBRARY_PLAYLISTS_UPDATE_FAIL'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET_FAIL =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_SET_FAIL'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE_FAIL =
  'CLIENT_LIBRARY_FEATURED_PLAYLISTS_UPDATE_FAIL'
export const CLIENT_LIBRARY_TRACKS_LOAD = 'CLIENT_LIBRARY_TRACKS_LOAD'
export const CLIENT_LIBRARY_TRACKS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_TRACKS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_TRACKS_LOAD_FAIL = 'CLIENT_LIBRARY_TRACKS_LOAD_FAIL'
export const CLIENT_LIBRARY_TRACKS_LOAD_NEXT = 'CLIENT_LIBRARY_TRACKS_LOAD_NEXT'
export const CLIENT_LIBRARY_TRACKS_LOAD_NEXT_SUCCESS =
  'CLIENT_LIBRARY_TRACKS_LOAD_NEXT_SUCCESS'
export const CLIENT_LIBRARY_TRACKS_LOAD_NEXT_FAIL =
  'CLIENT_LIBRARY_TRACKS_LOAD_NEXT_FAIL'
export const CLIENT_LIBRARY_FEATURED_TRACKS_LOAD =
  'CLIENT_LIBRARY_FEATURED_TRACKS_LOAD'
export const CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_FAIL =
  'CLIENT_LIBRARY_FEATURED_TRACKS_LOAD_FAIL'
export const CLIENT_LIBRARY_TRACKS_UPDATE = 'CLIENT_LIBRARY_TRACKS_UPDATE'
export const CLIENT_LIBRARY_TRACKS_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_TRACKS_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_TRACKS_UPDATE_FAIL =
  'CLIENT_LIBRARY_TRACKS_UPDATE_FAIL'
export const CLIENT_LIBRARY_TRACKS_SET = 'CLIENT_LIBRARY_TRACKS_SET'
export const CLIENT_LIBRARY_TRACKS_SET_SUCCESS =
  'CLIENT_LIBRARY_TRACKS_SET_SUCCESS'
export const CLIENT_LIBRARY_TRACKS_SET_FAIL = 'CLIENT_LIBRARY_TRACKS_SET_FAIL'
export const CLIENT_LIBRARY_CLIENTS_LOAD = 'CLIENT_LIBRARY_CLIENTS_LOAD'
export const CLIENT_LIBRARY_CLIENTS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_CLIENTS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_CLIENTS_LOAD_FAIL =
  'CLIENT_LIBRARY_CLIENTS_LOAD_FAIL'
export const CLIENT_LIBRARY_CLIENT_DELETE = 'CLIENT_LIBRARY_CLIENT_DELETE'
export const CLIENT_LIBRARY_CLIENT_DELETE_SUCCESS =
  'CLIENT_LIBRARY_CLIENT_DELETE_SUCCESS'
export const CLIENT_LIBRARY_CLIENT_DELETE_FAIL =
  'CLIENT_LIBRARY_CLIENT_DELETE_FAIL'
export const CLIENT_LIBRARY_CLIENT_UPDATE = 'CLIENT_LIBRARY_CLIENT_UPDATE'
export const CLIENT_LIBRARY_CLIENT_UPDATE_SUCCESS =
  'CLIENT_LIBRARY_CLIENT_UPDATE_SUCCESS'
export const CLIENT_LIBRARY_CLIENT_UPDATE_FAIL =
  'CLIENT_LIBRARY_CLIENT_UPDATE_FAIL'
export const CLIENT_LIBRARY_CLIENTS_INVITE = 'CLIENT_LIBRARY_CLIENTS_INVITE'
export const CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS =
  'CLIENT_LIBRARY_CLIENTS_INVITE_SUCCESS'
export const CLIENT_LIBRARY_CLIENTS_INVITE_FAIL =
  'CLIENT_LIBRARY_CLIENTS_INVITE_FAIL'
export const CLIENT_LIBRARY_INVITE_RESEND = 'CLIENT_LIBRARY_INVITE_RESEND'
export const CLIENT_LIBRARY_INVITE_RESEND_SUCCESS =
  'CLIENT_LIBRARY_INVITE_RESEND_SUCCESS'
export const CLIENT_LIBRARY_INVITE_RESEND_FAIL =
  'CLIENT_LIBRARY_INVITE_RESEND_FAIL'
export const CLIENT_LIBRARY_CLIENTS_RESET_ERRORS =
  'CLIENT_LIBRARY_CLIENTS_RESET_ERRORS'
export const CLIENT_LIBRARY_STATS_LOAD = 'CLIENT_LIBRARY_STATS_LOAD'
export const CLIENT_LIBRARY_STATS_LOAD_SUCCESS =
  'CLIENT_LIBRARY_STATS_LOAD_SUCCESS'
export const CLIENT_LIBRARY_STATS_LOAD_FAIL = 'CLIENT_LIBRARY_STATS_LOAD_FAIL'
export const CLIENT_LIBRARY_NOTIFICATION_RECEIVE =
  'CLIENT_LIBRARY_NOTIFICATION_RECEIVE'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_LOAD_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_SET_LOAD_FAIL'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_SUCCESS =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_SUCCESS'
export const CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_FAIL =
  'CLIENT_LIBRARY_DISCOVERY_PANEL_RECENT_LOAD_FAIL'
export const CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD =
  'CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD'
export const CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_SUCCESS =
  'CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_SUCCESS'
export const CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_FAIL =
  'CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_FAIL'
export const WATERMARKING_LOAD = 'WATERMARKING_LOAD'
export const WATERMARKING_LOAD_SUCCESS = 'WATERMARKING_LOAD_SUCCESS'
export const WATERMARKING_LOAD_FAIL = 'WATERMARKING_LOAD_FAIL'
export const WATERMARKING_LOAD_NEXT = 'WATERMARKING_LOAD_NEXT'
export const WATERMARKING_LOAD_NEXT_SUCCESS = 'WATERMARKING_LOAD_NEXT_SUCCESS'
export const WATERMARKING_LOAD_NEXT_FAIL = 'WATERMARKING_LOAD_NEXT_FAIL'
export const WATERMARKING_UPDATE_ITEMS = 'WATERMARKING_UPDATE_ITEMS'
export const WATERMARKING_PLAYLISTS_SEARCH_PARAMS_UPDATE =
  'WATERMARKING_SEARCH_PARAMS_UPDATE'
export const WATERMARKING_LEAKS_SEARCH_PARAMS_UPDATE =
  'WATERMARKING_LEAKS_SEARCH_PARAMS_UPDATE'
export const PRICING_RESET = 'PRICING_RESET'
export const PRICING_UPDATE = 'PRICING_UPDATE'
export const BILLING_PROVIDER_COMPONENTS_LOAD =
  'BILLING_PROVIDER_COMPONENTS_LOAD'
export const BILLING_PROVIDER_COMPONENTS_SUCCESS =
  'BILLING_PROVIDER_COMPONENTS_SUCCESS'
export const BILLING_PROVIDER_COMPONENTS_FAIL =
  'BILLING_PROVIDER_COMPONENTS_FAIL'
export const RESTART_SUBSCRIPTION = 'RESTART_SUBSCRIPTION'
export const LEAK_TRACING_NOTIFICATION_RECEIVE =
  'LEAK_TRACING_NOTIFICATION_RECEIVE'
export const SEATS_AND_TRACKS_UPDATE = 'SEATS_AND_TRACKS_UPDATE'
export const SEATS_AND_TRACKS_UPDATE_SUCCESS = 'SEATS_AND_TRACKS_UPDATE_SUCCESS'
export const SET_COPY_METADATA = 'SET_COPY_METADATA'
export const NESTING_LOAD = 'NESTING_LOAD'
export const NESTING_LOAD_ERROR = 'NESTING_LOAD_ERROR'
export const NESTING_TRACKS_LOAD_SUCCESS = 'NESTING_TRACKS_LOAD_SUCCESS'
export const NESTING_UPDATING = 'NESTING_UPDATING'
export const NESTING_UPDATING_SUCCESS = 'NESTING_UPDATING_SUCCESS'
export const NESTING_UPDATING_ERROR = 'NESTING_UPDATING_ERROR'
export const NESTING_RESET = 'NESTING_RESET'
// Mobile
export const RECIPIENT_SEARCH_PARAMS_UPDATE = 'RECIPIENT_SEARCH_PARAMS_UPDATE'
